import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { finalize } from 'rxjs/operators';
import { DeliveryService } from '../../../deliveries/services/delivery.service';
import { IDelivery } from '../../../model/interfaces/delivery';

@Component({
    selector: 'delivery-gatepass-number-dialog',
    templateUrl: './delivery-gatepass-number-dialog.component.html',
    standalone: false
})
export class DeliveryGatePassDialogComponent {
    doubleClickIsDisabled = false;

    @Input('delivery') delivery: IDelivery;
    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private notificationsService: NotificationsService,
        private deliveryService: DeliveryService,
    ) {}

    formSubmitted(ngForm: NgForm): void {
        const gatePassNumber = ngForm.form.value.gatePassNumber;
        if (!gatePassNumber) {
            this.notificationsService.error('Please enter a valid gatepass number.');
            return;
        }
        
        this.delivery.GatePassNumber = gatePassNumber;
        this.deliveryService.updateGatePassNumber(this.delivery)
            .pipe(finalize(() => this.doubleClickIsDisabled = false))
            .subscribe({
                next: () => {
                    this.notificationsService.success('Gate Pass Number Updated.');
                    this.close();
                }
            });
    }

    close(): void {
        this.onClose.emit();
    }
}
